
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Route, Router, UrlSegment, UrlTree } from '@angular/router';

import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';

import { ConfigService } from '../services/config.service';
import { StorageProvider } from '../services/storage.provider';

@Injectable({providedIn: 'root'})
export class ProfileGuard  {

  constructor(private storage: StorageProvider, protected http: HttpClient, private config: ConfigService, private router: Router) { }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | boolean {
    const configData = this.config.getEnvironmentConfig();
    const environment = configData.env;
    const accessToken = this.storage.getStorage('access_token');
    const uniq = localStorage.getItem('ID');
    const domain = configData.environments[environment].domain;

    // this if for autologin profiles?access_token=
    if (this.router.getCurrentNavigation().extractedUrl.queryParams.access_token && this.router.getCurrentNavigation().extractedUrl.queryParams.refresh_token) {
      return true;
    }

    if (!accessToken) {
      return new Observable(subscriber => {
        subscriber.next(false);
        this.router.navigate(['']);
        subscriber.complete();
      });
    }
    return this.http.get( domain + '/profils' + '?access_token=' + accessToken + '&device_identifier=' + uniq)
      .pipe(
        map((response: any) => {
          if (response.profiles) {
            return true;
          }

          this.router.navigate(['creer-compte','etape-2']);
          return false;
        },
        (error) => false
      ));
  }
}
